const LABELS = { show: "Show password", hide: "Hide password" }

document.addEventListener("click", event => {
  const toggle = event.target.closest("[data-password-toggle]")
  if (!toggle) return

  const field = toggle.closest(".password-field")
  const input = field && field.querySelector("input")
  if (!input) return

  const revealed = input.type === "password"
  input.type = revealed ? "text" : "password"
  field.classList.toggle("is-revealed", revealed)
  toggle.setAttribute("aria-label", revealed ? LABELS.hide : LABELS.show)
  toggle.setAttribute("aria-pressed", String(revealed))
})
